import { useStore } from '../../store';

export const WindowOfOpportunityCount = () => {
  const totalWindowsOfOpportunities = useStore(
    s => s.totalWindowsOfOpportunities
  );

  return <span>{totalWindowsOfOpportunities}</span>;
};
